import { i as useAppSelector, k as mainSlice, l as renderersLoadComponent, _ as __variableDynamicImportRuntimeHelper } from "./doenetml-jBZLIepG.js";
import React__default, { useState, useEffect } from "react";
function useDoenetRenderer(props, initializeChildrenOnConstruction = true) {
  const actions = props.componentInstructions.actions;
  const componentIdx = props.componentInstructions.componentIdx;
  const effectiveIdx = props.componentInstructions.effectiveIdx;
  const id = props.componentInstructions.id;
  const rendererName = props.coreId + componentIdx;
  const [renderersToLoad, setRenderersToLoad] = useState({});
  const componentInfo = useAppSelector(
    (state) => mainSlice.selectors.componentInfo(state)[rendererName]
  );
  const {
    stateValues,
    sourceOfUpdate = {},
    ignoreUpdate,
    childrenInstructions,
    prefixForIds
  } = componentInfo || {
    stateValues: {},
    sourceOfUpdate: {},
    ignoreUpdate: false,
    childrenInstructions: [],
    prefixForIds: ""
  };
  let children = [];
  const loadMoreRenderers = Object.keys(renderersToLoad).length === 0;
  for (let childInstructions of childrenInstructions) {
    let child = createChildFromInstructions(
      childInstructions,
      loadMoreRenderers
    );
    children.push(child);
  }
  useEffect(() => {
    if (Object.keys(renderersToLoad).length > 0) {
      renderersLoadComponent(
        Object.values(renderersToLoad),
        Object.keys(renderersToLoad)
      ).then((newRendererClasses) => {
        Object.assign(props.rendererClasses, newRendererClasses);
        setRenderersToLoad({});
      });
    }
  }, [renderersToLoad, props.rendererClasses]);
  function createChildFromInstructions(childInstructions, loadMoreRenderers2) {
    if (typeof childInstructions === "string" || childInstructions === null) {
      return childInstructions;
    }
    let propsForChild = {
      key: props.coreId + childInstructions.componentIdx,
      componentInstructions: childInstructions,
      rendererClasses: props.rendererClasses,
      coreId: props.coreId,
      docId: props.docId,
      activityId: props.activityId,
      callAction: props.callAction,
      fetchExternalDoenetML: props.fetchExternalDoenetML,
      requestScrollTo: props.requestScrollTo,
      flags: props.flags
    };
    let rendererClass = props.rendererClasses[childInstructions.rendererType];
    if (!rendererClass) {
      if (loadMoreRenderers2) {
        setRenderersToLoad((old) => {
          let rendererPromises = { ...old };
          if (!(childInstructions.rendererType in rendererPromises)) {
            rendererPromises[childInstructions.rendererType] = __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "./renderers/_error.tsx": () => import("./_error-C_2EaOnz.js"), "./renderers/alert.tsx": () => import("./alert-3oCCzZ3q.js"), "./renderers/angle.tsx": () => import("./angle-BZ9QyuHL.js"), "./renderers/answer.tsx": () => import("./answer-eNRArC31.js"), "./renderers/asList.tsx": () => import("./asList-FZXy7rba.js"), "./renderers/blockQuote.tsx": () => import("./blockQuote-C7S6Hie9.js"), "./renderers/boolean.tsx": () => import("./boolean-DBkuhhyI.js"), "./renderers/booleanInput.tsx": () => import("./booleanInput-mMUWKCOp.js"), "./renderers/br.tsx": () => import("./br-Ct0TpZKZ.js"), "./renderers/button.tsx": () => import("./button-DezTrdM8.js"), "./renderers/c.tsx": () => import("./c-CWm1AsyA.js"), "./renderers/cell.tsx": () => import("./cell-DT_bx6B9.js"), "./renderers/choiceInput.tsx": () => import("./choiceInput-D-BRbHaR.js"), "./renderers/circle.tsx": () => import("./circle-YjXstUsv.js"), "./renderers/cobwebPolyline.tsx": () => import("./cobwebPolyline-CLaEgfu0.js"), "./renderers/codeEditor.tsx": () => import("./codeEditor-5vtcQYBJ.js"), "./renderers/containerBlock.tsx": () => import("./containerBlock-DQJlnrjU.js"), "./renderers/containerInline.tsx": () => import("./containerInline-CPqkYml8.js"), "./renderers/curve.tsx": () => import("./curve-nCuLO311.js"), "./renderers/ellipsis.tsx": () => import("./ellipsis-EXEZ9r7V.js"), "./renderers/em.tsx": () => import("./em-DH7MPZoa.js"), "./renderers/embed.tsx": () => import("./embed-2ENxIAJO.js"), "./renderers/feedback.tsx": () => import("./feedback-4eUqqIhM.js"), "./renderers/figure.tsx": () => import("./figure-Dh7pDbsB.js"), "./renderers/footnote.tsx": () => import("./footnote-BM_YhDf0.js"), "./renderers/graph.tsx": () => import("./graph-nKjcVV0x.js"), "./renderers/hint.tsx": () => import("./hint-CcEO02Ue.js"), "./renderers/hr.tsx": () => import("./hr-_Hp92PP6.js"), "./renderers/image.tsx": () => import("./image-CY1cbU9o.js"), "./renderers/label.tsx": () => import("./label-Cs7wSS2X.js"), "./renderers/legend.tsx": () => import("./legend-MdQaX17b.js"), "./renderers/line.tsx": () => import("./line-e7-3ksQ6.js"), "./renderers/lineSegment.tsx": () => import("./lineSegment-BG6qPBVL.js"), "./renderers/list.tsx": () => import("./list-Dx8EERF_.js"), "./renderers/lq.tsx": () => import("./lq-B3RfPvwX.js"), "./renderers/lsq.tsx": () => import("./lsq-shB_O6nW.js"), "./renderers/math.tsx": () => import("./math-Bp3Rf8o3.js"), "./renderers/mathInput.tsx": () => import("./mathInput-BFRqzWCq.js"), "./renderers/matrixInput.tsx": () => import("./matrixInput-D_GFBf8_.js"), "./renderers/mdash.tsx": () => import("./mdash-DI3B9qwC.js"), "./renderers/nbsp.tsx": () => import("./nbsp-hB6Tg5XN.js"), "./renderers/ndash.tsx": () => import("./ndash-Bbyl6Egs.js"), "./renderers/number.tsx": () => import("./number-CBPOVQRb.js"), "./renderers/orbitalDiagram.tsx": () => import("./orbitalDiagram-V5kW0a88.js"), "./renderers/orbitalDiagramInput.tsx": () => import("./orbitalDiagramInput-bblCOqy6.js"), "./renderers/p.tsx": () => import("./p-LGuaTKuv.js"), "./renderers/paginatorControls.tsx": () => import("./paginatorControls-CpqDsisV.js"), "./renderers/pegboard.tsx": () => import("./pegboard-ChjdWLfP.js"), "./renderers/point.tsx": () => import("./point-De2Ur5n_.js"), "./renderers/polygon.tsx": () => import("./polygon-CdTjVsjx.js"), "./renderers/polyline.tsx": () => import("./polyline-O7z1bW0F.js"), "./renderers/pre.tsx": () => import("./pre-BRw_Dgmx.js"), "./renderers/pretzel.tsx": () => import("./pretzel-B-CSX3Ir.js"), "./renderers/q.tsx": () => import("./q-BoPFt-j8.js"), "./renderers/ray.tsx": () => import("./ray-BkfnzHgc.js"), "./renderers/ref.tsx": () => import("./ref-CqE4RBDV.js"), "./renderers/regionBetweenCurveXAxis.tsx": () => import("./regionBetweenCurveXAxis-BZqraGaF.js"), "./renderers/regionBetweenCurves.tsx": () => import("./regionBetweenCurves-CzEaL-6j.js"), "./renderers/row.tsx": () => import("./row-DSx370mW.js"), "./renderers/rq.tsx": () => import("./rq-DxNWnJl1.js"), "./renderers/rsq.tsx": () => import("./rsq-DPvBtQrr.js"), "./renderers/section.tsx": () => import("./section-CTzJKl6v.js"), "./renderers/sideBySide.tsx": () => import("./sideBySide-eFqeRBRn.js"), "./renderers/slider.tsx": () => import("./slider-DdG0N9rB.js"), "./renderers/solution.tsx": () => import("./solution-NRduNepI.js"), "./renderers/spreadsheet.tsx": () => import("./spreadsheet-BZK8INOm.js"), "./renderers/sq.tsx": () => import("./sq-NbpHZEkt.js"), "./renderers/subsetOfRealsInput.tsx": () => import("./subsetOfRealsInput-Lo_zou4X.js"), "./renderers/summaryStatistics.tsx": () => import("./summaryStatistics-qLV3QAso.js"), "./renderers/table.tsx": () => import("./table-43t0eNgC.js"), "./renderers/tabular.tsx": () => import("./tabular-D8W466pW.js"), "./renderers/tag.tsx": () => import("./tag-CPSD5MW-.js"), "./renderers/text.tsx": () => import("./text-wYnvOnDw.js"), "./renderers/textInput.tsx": () => import("./textInput-DS2VI3jr.js"), "./renderers/vector.tsx": () => import("./vector-BNXIpYBJ.js"), "./renderers/video.tsx": () => import("./video-DkxPjSPM.js") }), `./renderers/${childInstructions.rendererType}.tsx`, 3);
          }
          return rendererPromises;
        });
      }
      return null;
    }
    let child = React__default.createElement(rendererClass, propsForChild);
    return child;
  }
  let rendererType = props.componentInstructions.rendererType;
  const callAction = (argObj) => {
    if (!argObj.componentIdx) {
      argObj = { ...argObj };
      argObj.componentIdx = componentIdx;
    }
    if (!argObj.rendererType) {
      argObj = { ...argObj };
      argObj.rendererType = rendererType;
    }
    return props.callAction(argObj);
  };
  return {
    componentIdx: effectiveIdx,
    id: prefixForIds + id,
    SVs: stateValues,
    docId: props.docId,
    activityId: props.activityId,
    actions,
    children,
    sourceOfUpdate,
    ignoreUpdate,
    rendererName,
    initializeChildren: () => {
    },
    callAction,
    doenetViewerUrl: props.doenetViewerUrl,
    fetchExternalDoenetML: props.fetchExternalDoenetML,
    requestScrollTo: props.requestScrollTo,
    flags: props.flags
  };
}
export {
  useDoenetRenderer as u
};
